import React from 'react';
import BadgeCard from './BadgeCard';
import {
	GetProfileScoreAPIResponse,
	GetUserProfileAPIResponse,
	InterviewedByDetails,
	RoundType,
	Skill,
	UIBadge,
	UserSkillRatingDocument,
} from 'types';
import ProfileContentHeader from '../ProfileContentHeader';
import ProfileSkillSection from '../ProfileSkillSection';
import MuiTooltip from '@mui/material/Tooltip';
import { isRecruiterSide } from 'src/config/env.config';
import { MuiTooltipcontent, Tooltipcontent } from 'src/components/shared/assessSkills/AssessedSkills';
import { BsInfoCircleFill } from 'react-icons/bs';
import { Tooltip } from 'flowbite-react';
import { isScoreRangeValid } from 'shared-utils';

const Badges = ({
	title,
	// isSelf,
	skills, // userProfile,
	// resumeSkills,
} // interviewedByDetails,
: {
	title: string;
	// isSelf: boolean;
	// resumeSkills?: Skill[];
	skills: UserSkillRatingDocument[];
	// userProfile?: GetUserProfileAPIResponse;
	// interviewedByDetails?: InterviewedByDetails[];
}) => {
	const badgesList: UIBadge[] = [
		{
			title: 'Expert',
			skill: 'Javacript',
			maxScore: 1000,
			minScore: 750,
			scoreRange: '750+',
		},
		{
			title: 'Advanced',
			skill: 'Problem Solving',
			maxScore: 750,
			minScore: 500,
			scoreRange: '500 - 750',
		},
		{
			title: 'Intermediate',
			skill: 'Coding skills',
			maxScore: 500,
			minScore: 250,
			scoreRange: '250 - 500',
		},
		{
			title: 'Beginner',
			skill: 'DSA',
			maxScore: 250,
			minScore: 1,
			scoreRange: '1 - 250',
		},
	];

	const getBadgesWithSkills = () => {
		const badgesWithSkills = badgesList.map(badge => {
			const filteredSkills = (skills?.length ? skills || [] : []).filter(item => {
				const score = isScoreRangeValid(Math.round(item.rating));
				return score >= badge.minScore && score < badge.maxScore;
			});
			return { ...badge, skills: filteredSkills };
		});

		// Sort badges by the number of skills, descending
		return badgesWithSkills
			.sort((a, b) => b.skills.length - a.skills.length)
			.slice(0, 2)
			.sort((a, b) => b.minScore - a.minScore);
	};

	const topTwoBadges = getBadgesWithSkills();

	return !topTwoBadges?.filter(e => e?.skills?.length)?.length ? null : (
		<>
			<ProfileContentHeader data={{ name: title, isImp: false }} />

			<div>
				<h5 className="text-sm font-[500] text-[#28293D] font-inter px-6 pb-2 pt-6 flex gap-1">
					<span>Badges</span>
					<span className="w-fit flex items-center justify-center">
						{isRecruiterSide ? (
							<MuiTooltip
								title={
									<MuiTooltipcontent
										title={'Badges'}
										description={'Badges are awarded based on the skills assessed in an Technical Round on LevelUp'}
									/>
								}
								arrow={false}
							>
								<div className="w-max">
									<BsInfoCircleFill cursor={'pointer'} size={'12px'} onClick={() => null} />
								</div>
							</MuiTooltip>
						) : (
							<MuiTooltip
								title={
									<MuiTooltipcontent
										title={'Badges'}
										description={'Badges are awarded based on the skills assessed in an Technical Round on LevelUp'}
									/>
								}
								arrow={false}
							>
								<div className="w-max">
									<BsInfoCircleFill cursor={'pointer'} size={'12px'} onClick={() => null} />
								</div>
							</MuiTooltip>
						)}
					</span>
				</h5>

				<div className="grid md:flex flex-wrap grid-cols-1 gap-[12px] px-6 pb-6">
					{topTwoBadges.map((badgeWithSkills, index) => (
						<BadgeCard key={index} badge={badgeWithSkills} skills={badgeWithSkills?.skills} />
					))}
				</div>
			</div>
		</>
	);
};

export default Badges;
